import { render, staticRenderFns } from "./PricingFeatures.vue?vue&type=template&id=3a557a86&scoped=true"
import script from "./PricingFeatures.js?vue&type=script&lang=js&external"
export * from "./PricingFeatures.js?vue&type=script&lang=js&external"
import style0 from "./PricingFeatures.scss?vue&type=style&index=0&id=3a557a86&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a557a86",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default})
